import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ApContentService } from '@ap/content';

import content from './logout-page.content.json';

/**
 * @ngdoc component
 * @name LogoutPageComponent
 * @module LogoutPageModule
 */
@Component({
    selector: 'logout-page',
    templateUrl: './logout-page.component.html',
    standalone: false
})
export class LogoutPageComponent {
    public constructor(
        private readonly contentService: ApContentService,
        private readonly router: Router
    ) {
        this.contentService.addContentItems(content);
    }

    public navigateToLogin(): void {
        this.router.navigate(['/']);
    }
}
